module.exports = __webpack_public_path__ + "img/Add-Card-Advertisement.c91ac5fa.svg";